const embedVideos = document.querySelectorAll(".embed-video__item");
const videoObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            const video = entry.target;
            video.src = video.dataset.src;
            video.onload = function () {
                video.parentElement.classList.add("is-loaded");
            };
            videoObserver.unobserve(video);
        }
    });
});

embedVideos.forEach((video) => {
    videoObserver.observe(video);
});
